
import { BookkeepingService, BookYearService, CustomerService } from "@/services";
import { HumanFilter } from "@/utils/human-filter";
import { IQueryFilters } from "@/utils/query-params";
import Vue from "vue";
import { ConfirmResult } from "winfakt-vue-components";
import AppAccountVatListingAmbigousClientsModal from "./AccountingVatListingAmbigousClientsModal.vue";

export default Vue.extend({
	data(){
		return {
			sending: false,
			year: BookYearService.selectedBookYear,
			data: null as any,
			onClientsModalConfirmFunction: null as null | Function
		};
	},
	watch: {
		year: {
			handler(){
				this.data = null;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async downloadData(){
			if (this.data) return;
			try{
				let count = await CustomerService.getWithAmbigousVatCount();
				if (count > 0) {
					let result:ConfirmResult = await new Promise((resolve)=>{
						this.onClientsModalConfirmFunction = resolve;
					});
					this.onClientsModalConfirmFunction = null;
					if (result == ConfirmResult.CANCEL){
						return;
					}
					if (result == ConfirmResult.YES) {
						let filters = [new HumanFilter({Field: "is-particulier", Values: ["false"]}), new HumanFilter({Field: "this.Vat", Operator: "=", Values: [""]})];
						let packed:IQueryFilters = {filters};
						this.$router.push(`/contacts/customers?filters=${JSON.stringify(packed)}`);
						return;
					}
				}
				this.data = await BookkeepingService.vatListingGenerateData(this.year);
			}catch(err){
			}
		},
		async download(){
			this.sending = true;
			try{
				await this.downloadData();
				if (!this.data) return;
				BookkeepingService.vatListingDownloadXml(this.data, this.year);
			}catch(err){
			}finally{
				this.sending = false;
			}
		},
		async downloadPdf(){
			this.sending = true;
			try{
				await this.downloadData();
				if (!this.data) return;
				BookkeepingService.vatListingDownloadPdf(this.data, this.year);
			}catch(err){
			}finally{
				this.sending = false;
			}
		},
	},
	components: {
		AppAccountVatListingAmbigousClientsModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
